import ActionColumnComponent from "../../../disaster/components/ActionColumn/ActionColumn";

export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Business Assets": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "URL",
        dataIndex: "URL",
        key: "url",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Financial Statements": [
        {
          title: "Name",
          dataIndex: "Name",
          key: "name",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "URL",
          dataIndex: "URL",
          key: "url",
          render: (record) => (record ? record : "N/A"),
        },
        actionColumn,
      ],
      "Tax Returns": [
        {
          title: "Name",
          dataIndex: "Name",
          key: "name",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "URL",
          dataIndex: "URL",
          key: "url",
          render: (record) => (record ? record : "N/A"),
        },
        actionColumn,
      ],
      "Partnership Agreements": [
        {
          title: "Name",
          dataIndex: "Name",
          key: "name",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "URL",
          dataIndex: "URL",
          key: "url",
          render: (record) => (record ? record : "N/A"),
        },
        actionColumn,
      ],
      "Client Lists": [
        {
          title: "Name",
          dataIndex: "Name",
          key: "name",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "URL",
          dataIndex: "URL",
          key: "url",
          render: (record) => (record ? record : "N/A"),
        },
        actionColumn,
      ],
      "Intellectual Property": [
        {
          title: "Name",
          dataIndex: "Name",
          key: "name",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "URL",
          dataIndex: "URL",
          key: "url",
          render: (record) => (record ? record : "N/A"),
        },
        actionColumn,
      ],
 
   
  };
};
